import { Button, Form, Icon, Input, DatePicker } from "antd";
import React, { Component } from "react";
import "./SearchForm.css";
import moment from "moment";

const { RangePicker } = DatePicker;

class Search extends Component {
  componentDidMount() {
    if (typeof this.props.onRef === "function") this.props.onRef(this);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.fn(this.props.form);
  };

  handleReset = () => {
    this.props.form.resetFields();
    this.props.fnReset();
  };

  clearTxtSearch = () => {
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { placeholder, width, isShowRangeDate } = this.props;

    return (
      <Form className="search-frm" layout="inline" onSubmit={this.handleSubmit}>
        {isShowRangeDate && (
          <Form.Item style={{ textAlign: "center", marginRight: "10px" }}>
            {getFieldDecorator(
              "range_date",
              {
                rules: [{ required: true }],
                initialValue: [moment().subtract(1, "M"), moment()],
              }
            )(
              <RangePicker
                disabledDate={(_date) =>
                  _date > moment().add(1, "h") ||
                  _date < moment().subtract(3, "M")
                }
                separator="-"
              />
            )}
          </Form.Item>
        )}
        <Form.Item style={{ marginRight: "10px" }}>
          {getFieldDecorator("searchTxt")(
            <Input
              prefix={
                <Icon type="search" style={{ color: "rgba(0,0,0,.25)" }} />
              }
              placeholder={placeholder || "Search"}
              style={{ width: width || "100%" }}
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button.Group>
            <Button htmlType="submit" icon="search" />
            <Button icon="redo" onClick={this.handleReset} />
          </Button.Group>
        </Form.Item>
      </Form>
    );
  }
}

const SearchForm = Form.create({ name: "search-frm" })(Search);

export default SearchForm;



// WEBPACK FOOTER //
// ./src/containers/SearchForm/index.js